import { FillBtn } from '../../ui';
import classes from '../news.module.css';
import { Trans, useTranslation } from 'react-i18next';

export const Update514 = () => {
    const { t } = useTranslation(['news']);
    return (
        <div className={classes.wrapper}>
            <div className={classes.news}>{t('title')}</div>
            <div className={classes.containerNews}>
                <div className={classes.blockNews}>
                    <div className={classes.textNews} itemScope itemType="http://schema.org/NewsArticle">
                        <meta itemProp="mainEntityOfPage" content="True" />
                        <div className={classes.titleNews}>
                            <span itemProp="headline">Оновлення 5.1.4: Відновлення ключових функцій та стабільність роботи</span>
                        </div>
                        {/* @ts-ignore */}
                        <div className={classes.dateNews} itemProp="datePublished" content="2025-04-15T00:00:00+08:00">15/04/2025</div>
                        <meta itemProp="dateModified" content="2025-04-15T00:00:00+08:00" />
                        <div className={classes.descriptionNews}>
                            <p itemProp="description"><b>Вітаємо!</b> Ми випустили оновлення 5.1.4, яке виправляє низку проблем, спричинених нещодавніми змінами на Rozetka, та покращує стабільність роботи True Price.</p>
                            <div itemProp="articleBody">
                                <h3 className={classes.articleHeadlines}>Що нового в 5.1.4:</h3>
                                <ul>
                                    <li><b>Відновлено шильдик реальної знижки:</b> Тепер ви знову бачите актуальний відсоток знижки на картці товару.</li>
                                    <li><b>Відновлено кнопку "Відстежувати":</b> Функція відстеження цін знову доступна безпосередньо на картці товару.</li>
                                    <li><b>Відновлено сортування за реальною знижкою:</b> Можливість сортувати товари за найвигіднішою знижкою повернулася.</li>
                                    <li><b>Виправлено помилки покращеного меню:</b> Усунуто проблеми, що виникали під час використання нових фільтрів.</li>
                                    <li><b>Додано видалення рекламних товарів:</b> Тепер True Price приховує рекламні блоки у видачі товарів на Rozetka для чистішого перегляду.</li>
                                    <li><b>Полагоджено віджет порівняння товарів:</b> Віджет знову коректно працює та показує ціни в інших магазинах.</li>
                                </ul>

                                <h3 className={classes.articleHeadlines}>Трохи контексту</h3>
                                <p className={classes.articleText}>
                                    Останнім часом Rozetka вносила багато змін у свій сайт, що призвело до поломки багатьох функцій True Price. Деякі базові дані, на які ми спиралися, були змінені або видалені.
                                </p>
                                <p className={classes.articleText}>
                                    Ми не стали чекати, поки Rozetka виправить ці проблеми зі свого боку, і переписали значну частину коду, щоб якнайшвидше відновити працездатність розширення. Це потребувало багато часу та зусиль.
                                </p>

                                <h3 className={classes.articleHeadlines}>Проблеми зі світлом та рішення</h3>
                                <p className={classes.articleText}>
                                    На жаль, нещодавно весь проект був недоступний протягом тижня через проблеми з електропостачанням. Щоб уникнути подібних ситуацій у майбутньому, ми придбали джерело безперебійного живлення (ДБЖ). Тепер True Price готовий до відключень і працюватиме стабільніше.
                                </p>

                                <h3 className={classes.articleHeadlines}>Залишайтеся на зв'язку</h3>
                                <p className={classes.articleText}>
                                    Нагадуємо про наш <a className={classes.link} href='https://t.me/true_price_ua' target='_blank'>Telegram-канал</a>. Там ми публікуємо оперативні новини про стан сервісу (наприклад, під час відключень) та короткі анонси нових версій. Підписуйтесь, щоб бути в курсі!
                                </p>

                                <p className={classes.articleText}>
                                    <b>Дякуємо за підтримку!</b> Ми цінуємо ваше терпіння та підтримку. Продовжуйте користуватися True Price та ділитися ним з друзями!
                                </p>
                            </div>
                        </div>
                        <meta itemProp="author" content="Вадим Петров" />
                        <div itemProp="publisher" itemScope itemType="http://schema.org/Organization">
                            <meta itemProp="name" content="True Price" />
                            <div itemProp="logo" itemScope itemType="http://schema.org/ImageObject">
                                <meta itemProp="url" content="/video/poster-hor.webp" />
                                <meta itemProp="width" content="600" />
                                <meta itemProp="height" content="60" />
                            </div>
                        </div>
                        <meta itemProp="image" content="/news-assets/news.jpg" />
                        <div className={classes.imgNews} style={{ width: '100%' }}>
                            <img src='/news-assets/5-1-4.webp' alt='Оновлення 5.1.4' itemProp="image" />
                        </div>
                        <div className={classes.alignCenter} style={{ 'marginTop': '30px' }}>
                            <a href='https://true-price.top/news'><FillBtn>Назад до всіх новин</FillBtn></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};